export default __webpack_public_path__ + "static/media/liverpool2.07953662.jpg";